function Categories (element, options = {}) {
    if (!element) {
        return;
    }

    const categories = [...element.querySelectorAll('[data-category-tree-tag]')];

    const triggers = [];
    const panels = [];

    if (categories && categories.length > 0) {
        categories.forEach(category => {
            const trigger = category.querySelector('[data-category-tree-trigger]');
            triggers.push(trigger);
            const target = category.nextElementSibling;
            panels.push(target);

            trigger.addEventListener('click', () => {
                let currentState = history.state;
                let expanded = trigger.getAttribute('aria-expanded') === 'true' || false;

                if (!expanded) {
                    triggers.forEach((but) => but.setAttribute('aria-expanded', expanded));
                    panels.forEach((panel) => panel.hidden = true);
                    let slug = trigger.getAttribute('data-slug') || ' ';
                    history.replaceState(currentState, null, `#${slug.toLowerCase().trim().replace(/\s+/gi,'-')}`);
                } else {
                    history.replaceState(currentState, null, ' ');
                }

                trigger.setAttribute('aria-expanded', !expanded);
                target.hidden = expanded;
            });
        });
    }

    function getHashFromString(str) {
        if (!str || typeof str !== 'string') {
            return '';
        }
        return str.substring(str.indexOf('#') + 1);
    }

    const hashOnLoad = getHashFromString(decodeURI(location.hash)).toLowerCase();
    if (hashOnLoad) {
        const startTrigger = triggers.find(t => t?.dataset?.slug?.toLowerCase()?.trim()?.replace(/\s+/gi,'-') === hashOnLoad);
        if (startTrigger) {
            startTrigger.dispatchEvent(new Event('click'));
        }
    }
}
export default Categories;